import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import { getAllItems } from "./destinationAxios";

// Get All Destinations
export const GetALLDestination = createAsyncThunk(
  "destination/get-all",
  async (thunkAPI) => {
    try {
      return getAllItems();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const initialState = {
  destinations: [],
  isLoading: false,
  isDSuccess: false,

  isError: false,
  destination: "",
  message: "",
};

// Country Slice .............
export const destinationSlice = createSlice({
  name: "destination",
  initialState,
  reducers: {
    setDestination: (state, { payload }) => {
      state.destination =
        state?.data?.find((item) => item.id == payload) || null;
      console.log(payload);
    },
  },

  extraReducers: (builder) => {
    builder

      // Get all Status
      .addCase(GetALLDestination.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(GetALLDestination.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isDSuccess = true;
        state.isError = false;
        state.destinations = action?.payload?.data || "";
      })
      .addCase(GetALLDestination.rejected, (state, action) => {
        state.isLoading = false;
        state.isDSuccess = false;
        state.isError = true;
        state.message = action.error;
      });
  },
});

export const resetStateDestination = createAction("Reset_all");
export default destinationSlice.reducer;
export const { setDestination } = destinationSlice.actions;
